import { commonNameColsByProvider } from '../common.cols';
import { PROGRESSION_PARENT_MODEL, PROGRESSION_TABLE_MODEL } from '../model';
import { PM_PROVIDERS } from 'common/constants/constants';

const mapParentEntityName = {
  [PM_PROVIDERS.JIRA]: 'INITIATIVE',
  [PM_PROVIDERS.AZURE_BOARDS]: 'EPIC'
};

const mapChildEntityName = {
  [PM_PROVIDERS.JIRA]: 'ISSUES',
  [PM_PROVIDERS.AZURE_BOARDS]: 'WORK ITEMS'
};

const useParentOneCols = ({ pmProvider, isTreeHierarchyEnabled }) => {
  const commonNameCols = commonNameColsByProvider[pmProvider];
  const parentEntityName = isTreeHierarchyEnabled
    ? 'PARENT'
    : mapParentEntityName[pmProvider];

  const childEntityName = isTreeHierarchyEnabled
    ? 'CHILDREN'
    : mapChildEntityName[pmProvider];

  const cols = [
    ...commonNameCols,
    {
      dataPoint: PROGRESSION_TABLE_MODEL.ASSIGNEES_CELL,
      name: 'ASSIGNEES'
    },
    {
      dataPoint: PROGRESSION_TABLE_MODEL.PARENT_CELL,
      name: parentEntityName
    },
    {
      dataPoint: PROGRESSION_TABLE_MODEL.PROGRESS_CELL,
      name: 'PROGRESS',
      sortPoint: PROGRESSION_PARENT_MODEL.PROGRESS,
      isSortedCol: true
    },
    {
      dataPoint: PROGRESSION_TABLE_MODEL.LAST_ACTIVITY_CELL,
      name: 'LAST ACTIVITY'
    },
    {
      dataPoint: PROGRESSION_TABLE_MODEL.TOTAL_CELL,
      name: childEntityName
    },
    {
      dataPoint: PROGRESSION_TABLE_MODEL.STATUS_CELL,
      name: 'DELIVERY STATUS',
      sortPoint: PROGRESSION_PARENT_MODEL.STATUS,
      isSortedCol: true
    }
  ];

  return cols;
};

export default useParentOneCols;
